// Style overrides that must adapt between light and dark use the per-slot
// `({ theme }) => ({...})` callback form so they read the live palette
// instead of a hardcoded hex baked into one mode.
export const componentOverrides = {
  MuiCssBaseline: {
    styleOverrides: {
      body: ({ theme }) => ({ scrollbarColor: `${theme.palette.grey[300]} transparent` }),
    },
  },
  MuiButton: {
    defaultProps: { disableElevation: true },
    styleOverrides: {
      root: { textTransform: 'none', fontWeight: 600, borderRadius: 6, padding: '6px 16px' },
      sizeLarge: { padding: '10px 20px', fontSize: '0.9375rem' },
      sizeSmall: { padding: '3px 10px', fontSize: '0.8125rem' },
    },
  },
  MuiCard: {
    defaultProps: { elevation: 0 },
    styleOverrides: {
      // Floating card on a tinted canvas: no border, two-layer shadow —
      // not the flat bordered-card look. Shadow stays a fixed dark tint in
      // both modes (it reads correctly against either background.default).
      root: {
        border: 'none',
        borderRadius: 8,
        boxShadow: '0 1px 2px rgba(20,22,31,0.04), 0 2px 8px rgba(31,34,58,0.05)',
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: { padding: 12, '&:last-child': { paddingBottom: 12 } },
    },
  },
  MuiChip: {
    styleOverrides: {
      // Every status/platform chip in the redesign is a true pill.
      root: { borderRadius: 999, fontWeight: 600 },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: theme.palette.grey[50],
        '& th': {
          fontWeight: 600, fontSize: '0.75rem', textTransform: 'uppercase',
          letterSpacing: '0.05em', color: theme.palette.text.secondary,
        },
      }),
    },
  },
  MuiTextField: {
    defaultProps: { size: 'small', variant: 'outlined' },
  },
  MuiDialog: {
    defaultProps: { maxWidth: 'sm', fullWidth: true },
    styleOverrides: { paper: { borderRadius: 8 } },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: { border: 'none' },
    },
  },
  MuiAppBar: {
    defaultProps: { elevation: 0 },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        minHeight: '48px !important',
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: { borderRadius: 6 },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: { borderRadius: 6 },
    },
  },
  MuiPaper: {
    styleOverrides: {
      rounded: { borderRadius: 8 },
    },
  },
};
